import { createAsyncThunk } from '@reduxjs/toolkit'
import Tag from './tag-model'
import { delete_tag, load_tags, store_tag } from './tag-service'

export const LoadTagsAsync = createAsyncThunk<any, any>(
  'composer/load/tag',
  async (params: { uid: string }) => {
    return await load_tags(params)
  },
)

export const CreateTagAsync = createAsyncThunk<any, any>(
  'composer/create/tag',
  async (params: Tag) => {
    return await store_tag(params)
  },
)

export const DeleteTagAsync = createAsyncThunk<any, any>(
  'composer/delete/tag',
  async (params) => {
    return await delete_tag(params)
  },
)
